import { useEffect } from "react";

const DEFAULT_DESC =
  "HILDRETH TECHNOLOGIES LLC is a founder-led Florida technology company building practical digital products across healthcare, medical policy, travel, privacy, media, and creator technology.";

function setMeta(attr, key, content) {
  let el = document.head.querySelector(`meta[${attr}="${key}"]`);
  if (!el) {
    el = document.createElement("meta");
    el.setAttribute(attr, key);
    document.head.appendChild(el);
  }
  el.setAttribute("content", content);
}

function setCanonical(href) {
  let el = document.head.querySelector('link[rel="canonical"]');
  if (!el) {
    el = document.createElement("link");
    el.setAttribute("rel", "canonical");
    document.head.appendChild(el);
  }
  el.setAttribute("href", href);
}

export function useSeo({ title, description, path = "" }) {
  useEffect(() => {
    const fullTitle = title
      ? `${title} | Hildreth Technologies LLC`
      : "Hildreth Technologies LLC | Practical Technology for Real-World Problems";
    const desc = description || DEFAULT_DESC;
    const origin =
      typeof window !== "undefined" ? window.location.origin : "";
    const url = `${origin}${path}`;

    document.title = fullTitle;
    setMeta("name", "description", desc);
    setMeta("property", "og:title", fullTitle);
    setMeta("property", "og:description", desc);
    setMeta("property", "og:url", url);
    setMeta("name", "twitter:title", fullTitle);
    setMeta("name", "twitter:description", desc);
    setCanonical(url);
    window.scrollTo(0, 0);
  }, [title, description, path]);
}
